// src/pages/NotFound/NotFound.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import "../../../assets/css/components/general/notFound/NotFound.css";

const NotFound = () => {
  const navigate = useNavigate();

  // Optional: Auto redirect after 10 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      // navigate('/');
    }, 10000);

    return () => clearTimeout(timer);
  }, [navigate]);

  const handleBackToHome = () => {
    navigate("/");
  };

  return (
    <div className="notfound-page">
      <div className="notfound-container">
        {/* 404 Illustration */}
        <div className="notfound-illustration">
          <img
            src="https://static.vecteezy.com/system/resources/previews/006/099/229/original/illustration-graphic-cartoon-character-of-not-connected-free-vector.jpg"
            alt="404 Not Found"
            className="notfound-image"
          />
        </div>

        {/* Content */}
        <div className="notfound-content">
          <h1 className="notfound-title">Oops! That Page Can't Be Found.</h1>
          <p className="notfound-description">
            You are here because you entered the address of a page that no
            longer exists or has been moved to a different address
          </p>
          <button className="back-home-btn" onClick={handleBackToHome}>
            <span>Back To Homepage</span>
            <FaArrowRight className="btn-arrow" />
          </button>
        </div>

        {/* Background Decoration */}
        <div className="background-decoration">
          <div className="decoration-circle circle-1"></div>
          <div className="decoration-circle circle-2"></div>
          <div className="decoration-circle circle-3"></div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
